export default "__VITE_ASSET__DJIYwzyQ__"